import { render, staticRenderFns } from "./PlacementConfigRadio.vue?vue&type=template&id=2728c562&scoped=true&"
import script from "./PlacementConfigRadio.vue?vue&type=script&lang=ts&"
export * from "./PlacementConfigRadio.vue?vue&type=script&lang=ts&"
import style0 from "./PlacementConfigRadio.vue?vue&type=style&index=0&id=2728c562&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2728c562",
  null
  
)

export default component.exports